import {  getIndexDetail } from "@/api/pm/table";
const state = {
    projectList:[]
}
const mutations = {
    SET_PROJECTLIST(state, projectList) {
        state.projectList = projectList
      },
}
const actions = {
    getProjectList ({ commit }) {
        return new Promise((resolve, reject) => {
            getIndexDetail().then(res=>{
                commit('SET_PROJECTLIST', res.data)
            })
        })
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
  }